import type { RouteConfig } from "vue-router";

import isUserLoggedIn from "@Middleware/isUserLoggedIn";

// Legacy settings routes
const Roles = () => import("@Views/organizations/profile/Roles.vue");
const SSO = () => import("@Views/organizations/profile/SSO.vue");
const SubscriptionSuccess = () => import("@Views/organizations/profile/Subscription/Success.vue");
const SubscriptionCancel = () => import("@Views/pricing/ConfirmCancellation.vue");
const Teams = () => import("@Views/organizations/teams/Index.vue");
const Members = () => import("@Views/organizations/teams/Members.vue");
const TeamDomains = () => import("@Views/organizations/teams/Domains.vue");

// New controller base settings routes
import OrgProfileSettingsController from "../Controllers/Settings/Organization/OrgProfileSettingsController.vue";
import OrgUsersSettingsController from "../Controllers/Settings/Organization/OrgUsersSettingsController.vue";
import OrgDomainsSettingsController from "../Controllers/Settings/Organization/OrgDomainsSettingsController.vue";
import OrgApiTokenSettingsController from "../Controllers/Settings/Organization/OrgApiTokenSettingsController.vue";
import UserProfileSettingsController from "../../users/Controllers/Settings/UserProfileSettingsController.vue";
import SecuritySettingsController from "@Modules/security-settings/Controllers/SecuritySettingsController.vue";
import OrgSubscriptionSettingsController from "../../subscriptions/Controllers/OrgSubscriptionSettingsController.vue";
import OrganizationOrdersController from "../../shoppingcart/Controllers/OrganizationOrdersController.vue";
import OrganizationOrderController from "../../shoppingcart/Controllers/OrganizationOrderController.vue";
import BillingSettingsController from "../../billing/Controllers/BillingSettingsController.vue";
import BillingTransactionsController from "../../billing/Controllers/BillingTransactionsController.vue";

const organization: RouteConfig[] = [
  {
    path: ":org/settings/user/profile",
    name: "org.settings.user.profile",
    component: UserProfileSettingsController,
  },
  {
    path: ":org/settings/user/security",
    name: "org.settings.user.security",
    component: SecuritySettingsController,
  },
  {
    path: ":org/settings/profile",
    name: "org.settings.profile",
    component: OrgProfileSettingsController,
  },
  {
    path: ":org/settings/profile/users",
    name: "org.settings.profile.users",
    component: OrgUsersSettingsController,
  },
  {
    path: ":org/settings/profile/roles",
    name: "org.settings.profile.roles",
    component: Roles,
  },
  {
    path: ":org/settings/profile/sso",
    name: "org.settings.profile.sso",
    component: SSO,
  },
  {
    path: ":org/settings/profile/domains",
    name: "org.settings.profile.domains",
    component: OrgDomainsSettingsController,
  },
  {
    path: ":org/settings/profile/subscription",
    name: "org.settings.profile.subscription",
    component: OrgSubscriptionSettingsController,
  },
  {
    path: ":org/settings/profile/subscription/success",
    name: "org.settings.profile.subscription.success",
    component: SubscriptionSuccess,
  },
  {
    path: ":org/settings/profile/subscription/cancel",
    name: "org.settings.profile.subscription.cancel",
    component: SubscriptionCancel,
  },
  {
    path: ":org/settings/profile/payment",
    name: "org.settings.profile.payment",
    component: BillingSettingsController,
  },
  {
    path: ":org/settings/profile/payment/transactions",
    name: "org.settings.profile.payment.transactions",
    component: BillingTransactionsController,
  },
  {
    path: ":org/settings/profile/orders",
    name: "org.settings.profile.orders",
    component: OrganizationOrdersController,
    alias: ":org/orders",
  },
  {
    path: ":org/orders",
    name: "org.shopping-cart.orders",
    component: OrganizationOrdersController,
  },
  {
    path: ":org/orders/:orderId",
    name: "org.shopping-cart.orders.order",
    component: OrganizationOrderController,
  },
];

const team: RouteConfig[] = [
  {
    path: ":org/settings/teams",
    name: "org.settings.teams",
    component: Teams,
  },
  {
    path: ":org/settings/teams/members",
    name: "org.settings.teams.members",
    component: Members,
  },
  {
    path: ":org/settings/teams/domains",
    name: "org.settings.teams.domains",
    component: TeamDomains,
  },
  {
    path: ":org/settings/teams/api",
    name: "org.settings.teams.api",
    component: OrgApiTokenSettingsController,
  },
];

// attach the common middleware on export
export default function TeamSettings(): RouteConfig[] {
  return [...organization, ...team].map((r) => ({
    ...r,
    meta: {
      navbarEnabled: false,
      middleware: [isUserLoggedIn],
    },
  }));
}
